module.exports = __webpack_public_path__ + "img/home_washing_machine_dots.64587603.svg";